import React, { FC } from 'react';

import { IForm, useForm } from '@.hooks';
import { Buttons } from '@.partials';
import { Input, Upload } from '@.ui';
import { noop } from '@/Lib';
import { LinkHelper } from '@/Services';
import { ParentCompanyCreateType, ParentCompanyResource } from '@/Types/ParentCompany';

import S from './ParentCompanyForm.module.scss';
import { createValidateOptions } from './validate';

interface ParentCompanyFormProps {
    initial?: Partial<ParentCompanyResource>;
    isEdit?: boolean;
    onSave?: (parentCompany: ParentCompanyCreateType, form: IForm<ParentCompanyCreateType>) => void;
}

export const ParentCompanyForm: FC<ParentCompanyFormProps> = ({ initial = {}, isEdit = false, onSave = noop }) => {
    const [field, form] = useForm<ParentCompanyCreateType>(initial);

    const onClickSave = () => {
        form.ifValid((data) => {
            onSave(data, form);
        }, createValidateOptions());
    };

    const onChangeImage = (imageId: number) => {
        form.set.values({
            image_id: imageId,
        });
    };

    return (
        <div>
            <Input className={S.name_input} {...field('name').register()} text="Parent company name" required />

            <h3 className={S.image_title}>Image</h3>

            <Upload.Image single value={initial.image || undefined} onChange={onChangeImage} />

            <Buttons text={isEdit ? 'Save' : 'Add'} onClickSave={onClickSave} linkCancel={LinkHelper.parentCompanies.all} />
        </div>
    );
};
